export { default as FreeAlert } from './FreeAlert.vue';
export { default as FreeAlertWithUseAlert } from './FreeAlertWithUseAlert.vue';
